// General on/off switch for staging-only code, so a new experiment doesn't need
// its own REACT_APP_* var wired into every docker-compose file. Enable a feature
// by adding its name to REACT_APP_STAGING_FEATURES (comma-separated) in the
// relevant config/*.env — left unset in production.
const enabled = new Set(
  (process.env.REACT_APP_STAGING_FEATURES || "")
    .split(",")
    .map((f) => f.trim())
    .filter(Boolean)
);

export function isStagingFeature(name) {
  return enabled.has(name);
}
